<div class="search-wrapper active" >
  <div class="input-holder">
    <input type="text" autocomplete="on" placeholder="Enter Claim ID / OIC Claim ID" (keyup.enter)="searchClaim()" [(ngModel)]="claimID" class="search-input">
    <button class="search-icon" (click)="searchClaim()"><span></span></button>
  </div>
  
</div>